import {calcExpectedDamageDiceFace} from "../../dice/calcExpectedDamageDiceFace";

// Бот без подкруток костей перебрасывает за дополнительное снабжение кость с
// этим значением и ниже: при честных гранях {-3,-2,-1,-1,0,0} матожидание
// переброса -7/6 (около -1.17), и выгоден переброс только "-2 и хуже"
export const BOT_FAIR_DICE_REROLL_THRESHOLD = -2;

// Есть ли у броска бота хоть какая-то подкрутка: пол выше 1 (уровень бонуса,
// давление) или прибавка к значению (уровень бонуса)
export const checkIfBotHasDiceBonus = (minRoll = 1, rollBonus = 0) => minRoll > 1 || rollBonus > 0;

/**
 * Перебрасывать ли боту кость урона за дополнительное снабжение — по самой
 * кости, без учета того, как грани складываются в урон и во что он
 * превращается. Так решает бот без подкруток костей (прежнее правило "-2 и
 * хуже"); бот с подкрутками решает по средней пользе исхода, см.
 * selectBotRerollDice. Порог "хуже матожидания" ниже — запасной путь для
 * ближнего боя, когда исход переброса не просчитать.
 *
 * Подкрутки берутся те, с которыми пройдет сам переброс в этом бою: пол
 * уровня бонуса, +1 к полу против игрока под давлением (getBotCombatD6MinRoll)
 * и прибавка к значению уровня бонуса (getBotD6RollBonus).
 *
 * С любой подкруткой бот перебрасывает кость, которая хуже матожидания
 * переброса: при поле 3 и выше грани -2 и -3 не выпадают вовсе, и прежний
 * порог "-2 и хуже" не срабатывал никогда — снабжение лежало без дела. Итог:
 *  - пол 2 (любой бот против игрока под давлением): -2 и -1;
 *  - пол 3 и 4, а также пол 3 с прибавкой +1: -1;
 *  - пол 6 («божество»): переброса нет — выпадает только лучшая грань.
 * Без подкруток — как раньше, см. BOT_FAIR_DICE_REROLL_THRESHOLD. Лучшая
 * грань 0 не перебрасывается ни при каких подкрутках: выше матожидания она
 * не бывает.
 *
 * Штраф форы новичкам (facePenalty, см. getLowRatingAdvantageDicePenalty)
 * сдвигает матожидание переброса вниз, и с подкрутками оно считается уже со
 * штрафом — иначе бот жег бы снабжение, перебрасывая -1 в расчете на 0,
 * которого у него нет. Боту без подкруток порог менять незачем там, где урон
 * — СУММА костей (ближний бой): со штрафом честная кость дает в среднем
 * -2, и выгоден по-прежнему переброс только «-2 и хуже» (-2 перебрасывать
 * уже незачем, но и не вредно). В стрельбе
 * катапульты, где берется лучшая или худшая из двух костей, по одной кости
 * под штрафом решать нельзя — там и такой бот идет по пользе исхода (см.
 * selectBotRerollDice).
 *
 * @param {number} face - текущая грань кости (-3..0)
 * @param {number} [minRoll=1] - пол броска d6 при перебросе
 * @param {number} [rollBonus=0] - прибавка к значению d6 при перебросе
 * @param {number} [facePenalty=0] - штраф к грани при перебросе
 * @returns {boolean}
 */
export const checkIfBotShouldRerollDamageDie = (face, minRoll = 1, rollBonus = 0, facePenalty = 0) => {
  if (!checkIfBotHasDiceBonus(minRoll, rollBonus)) {
    return face <= BOT_FAIR_DICE_REROLL_THRESHOLD;
  }

  return face < calcExpectedDamageDiceFace(minRoll, rollBonus, facePenalty);
};
